import React, { useEffect } from 'react';
import { IconButton, Snackbar, Theme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  close: {
    padding: theme.spacing(0.5),
  },
  success: {
    color: theme.colors.signupBlue,
  },
  error: {
    color: theme.colors.lipstick,
  },
  banner: {
    color: 'white',
    textAlign: 'center',
  },
  bannerContent: {
    backgroundImage: `linear-gradient(235deg, ${theme.colors.lipstickShadow}, ${theme.colors.lipstick})`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}));

type event = 'success' | 'error' | 'banner';

interface LPSnackBarProps {
  isOpen: boolean;
  type: event;
  message: string;
  autoHideDuration?: number;
  disableAutoHide?: boolean; 
  isDismissable?: boolean;
  onClose?: () => void;
}

export const LPSnackBar = (props: LPSnackBarProps) => {
  const { classes, cx } = useStyles();
  const { 
    isOpen, 
    type, 
    message, 
    autoHideDuration = 6000, 
    disableAutoHide = false, 
    isDismissable = true,
    onClose 
  } = props;
  const [open, setOpen] = React.useState(isOpen || false);

  const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);

    if (onClose) {
      onClose(); // Call the onClose callback if provided
    }
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <Snackbar
      anchorOrigin={
        type === 'banner'
          ? { vertical: 'top', horizontal: 'center' }
          : { vertical: 'bottom', horizontal: 'left' }
      }
      open={open}
      autoHideDuration={disableAutoHide ? null : autoHideDuration}
      onClose={handleClose}
      ContentProps={{
        'aria-describedby': 'message-id',
        className: cx({
          [classes.bannerContent]: type === 'banner',
        })
      }}
      message={
        <span
          className={cx({
            [classes.success]: type === 'success',
            [classes.error]: type === 'error',
            [classes.banner]: type === 'banner',
          })}
        >
          {message}
        </span>
      }
      action={
        isDismissable ? [
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            className={classes.close}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>,
        ] : undefined
      }
    />
  );
};
